import React, { useRef } from 'react'
import { makeStyles, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import { useHotkeys } from 'react-hotkeys-hook'

const useStyles = makeStyles((theme) => ({
}))

const SmartAutocomplete = (props: {
	id?: string,
	renderOption?: (option: any) => any,
	options: any[],
	label: string,
	keyName: string,
	onChange: (e: any, option: any) => void,
	value: any
	getOptionLabel: (option: any) => any,
	groupBy?: (option: any) => any,
	inputVariant?: string,
	style: any,
}) => {

	const {
		options,
		label,
		keyName,
		onChange,
		inputVariant = 'filled',
		getOptionLabel = (option: any) => option,
		value,
	} = props


	const classes = useStyles()

	useHotkeys(keyName, () => ref.current.focus(), { keyup: true, enableOnContentEditable: true })

	const ref = useRef<any | null>(null)

	const handleKeyPress = (e: any) => {

		
		if (e.keyCode === 9) {
			const enterPressEvent = new KeyboardEvent('keydown', {
				code: 'Enter',
				key: 'Enter',
				charCode: 13,
				keyCode: 13,
				view: window,
				bubbles: true
			})

			e.target.dispatchEvent(enterPressEvent)
		}

		// if ((e.keyCode === 13 || e.keyCode === 9) && options.map(option => getOptionLabel(option).toLowerCase()).includes(e.target.value.toLowerCase()) && e.target.value !== getOptionLabel(value)) {// enter, tab
		// 	console.log({ label, options, value: e.target.value })


		// 	onChange(e, options.find(option => getOptionLabel(option) === e.target.value))
		// 	ref.current.blur()
		// }
		// else
		if (e.keyCode === 13 || e.keyCode === 27) {// enter, escape
			ref.current.blur()
		}
 	}

	return (
		<Autocomplete
			{...props}
			autoHighlight
			// autoComplete
			blurOnSelect
			// @ts-ignore
			renderInput={(params) => <TextField inputRef={ref} {...params} label={label} variant={inputVariant} onKeyDown={handleKeyPress} />}
			onFocus={(e: any) => e.target.select()}
			onChange={(e, option) => { if (option === null) return; ref.current.blur(); onChange(e, option) }}
		/>
	)
}

export default SmartAutocomplete

// TODO : dunnot toLowerCase in some case (for example when searching on root input)
	// other option to disable autoHighlight for root input ?